import React from 'react';
import type { FeatureValue } from '../../data/pricing';
type FeatureCellProps = {
  value: FeatureValue;
};
export function FeatureCell({
  value
}: FeatureCellProps) {
  if (value === true) {
    return <span className="text-sm font-semibold text-brand-black" data-id="element-693" data-mp="3ufu0ndtwzogv">Yes</span>;
  }
  if (value === false) {
    return <>
        <span className="text-sm text-brand-gray" aria-hidden="true" data-id="element-694" data-mp="37oh0a13v7om">
          —
        </span>
        <span className="sr-only" data-id="element-695" data-mp="3koploe48o3m1">Not included</span>
      </>;
  }
  return <span className="text-sm font-medium text-brand-black" data-id="element-696" data-mp="3pgr7aqnar6oq">{value}</span>;
}